import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { map } from 'rxjs/operators';
import { SoilAnalysis, State } from 'src/app/soil-analysis/models/soil-analysis.models';
import { Environment } from 'src/environment';

@Injectable({
  providedIn: 'root',
})
export class SoilAnalysisApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/fieldregistration/';

  getDefaultSoilAnalyses() {
    return this.http
      .get<{ defaultSoilAnalyses: SoilAnalysis[] }>(`${this.baseUrl}soilanalysis/admin/default`)
      .pipe(map((result) => result.defaultSoilAnalyses));
  }

  upsertDefaultSoilAnalysis(defaultSoilAnalysis: SoilAnalysis) {
    return this.http.post(`${this.baseUrl}soilanalysis/admin/default`, defaultSoilAnalysis);
  }

  changeStateDefaultSoilAnalysis(id: number, state: State) {
    return this.http.post(`${this.baseUrl}soilanalysis/admin/default/${id}`, {
      state: state.toString(),
    });
  }
}
